import { render, staticRenderFns } from "./ClientMessage.vue?vue&type=template&id=1ba3800c&"
import script from "./ClientMessage.vue?vue&type=script&lang=js&"
export * from "./ClientMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports